import React, { useState } from 'react';
import IconButton from '@/ctComponents/IconButton';
import { Icons } from '@/assets';
import { EditChassis } from './edit-chassis';

const DataRow = ({ icon, label, value, isLast = false }) => {
  return (
    <div
      className={`flex justify-between ${
        !isLast
          ? 'border-t-0 border-l-0 border-r-0 border-b border-solid pb-2'
          : ''
      }`}>
      <span className="font-bold text-sm flex items-center">{label}</span>
      <span className="text-sm text-secondary-text">{value || 'N/A'}</span>
    </div>
  );
};

export const OwnChassisList = ({ chassisList, setChassisList }) => {
  const [openEditModal, setOpenEditModal] = useState(false);

  return (
    <>
      <div className="border border-solid pb-4 flex-1 rounded-md">
        <div className="flex justify-between items-center px-4">
          <h2 className="text-lg font-bold ">Own Chassis List</h2>

          <IconButton
            onClick={() => {
              setOpenEditModal(true);
            }}
            style={{ fontWeight: 400, height: 40 }}
            icon={'pen'}
            text={'Edit'}
            color={'#131617'}
            size={'big'}
          />
        </div>
        <hr
          className="mb-4 mt-0 border-t border-solid"
          style={{
            width: 'calc(100% - 32px)',
          }}
        />
        <div className="space-y-3 max-h-550 overflow-y-auto px-4">
          {chassisList.length > 0 ? (
            chassisList.map((chassis, index) => (
              <DataRow
                key={index}
                icon={Icons.company}
                label={`${index + 1}`}
                value={
                  chassis.name || chassis.chassisName || `Chassis-${index + 1}`
                }
                isLast={index === chassisList.length - 1}
              />
            ))
          ) : (
            <div className="text-center text-gray-500 py-4">
              No chassis found
            </div>
          )}
        </div>
      </div>

      <EditChassis
        show={openEditModal}
        setShow={setOpenEditModal}
        chassisList={chassisList}
        setChassisList={setChassisList}
      />
    </>
  );
};
